'use client';

import Image from 'next/image';
import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import ButtonBox from '@/components/ButtonBox';
import { MarkdownContent } from '@/components/v4/MarkdownContent';
import { AmplitudeContext } from '@/contexts/amplitude';
import { FreeAccountProps } from '@/types/cms';

const OpenYourAccount: React.FC<FreeAccountProps> = ({
  referId,
  image,
  title,
  buttons,
  analyticsSectionReference,
  qrCodeLink,
  isSectionTracker = false,
}) => {
  const { analytics } = useContext(AmplitudeContext);

  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView && analyticsSectionReference) {
      analytics?.track({
        event_type: 'section viewed',
        event_properties: {
          name: 'section viewed',
          description:
            'Evento disparado quando o usuário visualiza uma sessão especifica da pagina',
          section_reference: analyticsSectionReference,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analytics, inView]);

  return (
    <div
      ref={ref}
      id={referId}
      className="flex justify-center lg:p-40 py-40 lg:py-80 px-24"
    >
      <div className="flex flex-col md:flex-row gap-24 lg:gap-40 items-center p-24 lg:p-40 w-full max-w-[455px] md:max-w-[1060px] bg-display-100 rounded-6xl">
        <div className="md:flex-1 lg:flex-initial">
          <Image
            src={image.path}
            width={image.width}
            height={image.height}
            alt={image.alternativeText}
            quality={80}
            layout="intrinsic"
          />
        </div>
        <div className=" flex-1 lg:min-w-[380px]">
          <MarkdownContent
            className="font-display text-center md:text-left lg:heading-2 heading-3"
            content={title}
          />
          <ButtonBox
            buttons={buttons}
            section={
              isSectionTracker && analyticsSectionReference
                ? analyticsSectionReference
                : title
            }
            className="mt-16 md:mt-24"
            qrCodeLink={qrCodeLink}
          />
        </div>
      </div>
    </div>
  );
};

export default OpenYourAccount;
